import { contact } from '@/model/contact-person'

export default {
    pageTitle: 'MISSING FEATURE',
    poweredby: 'Powered by <strong>Trendexplorer</strong>, a product of &copy; <em>TRENDONE GmbH</em>',
    home: 'Visit dashboard',
    title: 'You do not have access to this area.',
    message: 'This feature is either not yet activated or no longer activated for your account. If you would like to use ' +
    'this area, please contact your administrator or contact us. We will be happy to help you.',
    contact: {
        phone: `You can reach us by phone at the following number: ${contact.phone}`,
        email: 'Or send us an e-mail to: '
    }
}
